module.exports = __webpack_public_path__ + "static/media/wave-sine.20bc342f.svg";